export function createCsvFile(headerColumns: string[], fileName: string): void {
    const CSV = headerColumns.join('\n');
    const file = new Blob([CSV], { type: 'text/csv' });
    const element = document.createElement('a');
    element.href = URL.createObjectURL(file);
    element.download = fileName;
    document.body.appendChild(element);
    element.click();
}

export function printCsvFileErrorMessages(messages: { [rowNumber: string]: string[] }, useRowAsIdentifier: boolean): string[] {
    const errorMessages: string[] = [];
    for (const key in messages) {
        for (const i in messages[key]) {
            errorMessages.push(!useRowAsIdentifier ? `${key} : ${messages[key][i]}` : `Row ${key} : ${messages[key][i]}`);
        }
    }
    return errorMessages;
}
